/**
 * Sweet Pockets Wishlist — localStorage based, no login required
 */
(function() {
  var STORAGE_KEY = 'sp_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch(e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    updateCounts();
  }

  function isInWishlist(handle) {
    return getWishlist().some(function(item) { return item.handle === handle; });
  }

  function addToWishlist(product) {
    var list = getWishlist();
    if (!list.some(function(item) { return item.handle === product.handle; })) {
      list.push({
        handle: product.handle,
        title: product.title,
        price: product.price,
        comparePrice: product.comparePrice || null,
        image: product.image,
        url: product.url,
        addedAt: Date.now()
      });
      saveWishlist(list);
    }
  }

  function removeFromWishlist(handle) {
    var list = getWishlist().filter(function(item) { return item.handle !== handle; });
    saveWishlist(list);
  }

  function toggleWishlist(product) {
    if (isInWishlist(product.handle)) {
      removeFromWishlist(product.handle);
      return false;
    } else {
      addToWishlist(product);
      return true;
    }
  }

  function updateCounts() {
    var count = getWishlist().length;
    var badges = document.querySelectorAll('.sp-wishlist-count');
    badges.forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function updateButtons() {
    var btns = document.querySelectorAll('[data-sp-wishlist-btn]');
    btns.forEach(function(btn) {
      var handle = btn.getAttribute('data-sp-wishlist-handle');
      if (isInWishlist(handle)) {
        btn.classList.add('sp-wishlisted');
        btn.setAttribute('aria-label', 'Remove from wishlist');
      } else {
        btn.classList.remove('sp-wishlisted');
        btn.setAttribute('aria-label', 'Add to wishlist');
      }
    });
  }

  function bindButtons() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-sp-wishlist-btn]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var product = {
        handle: btn.getAttribute('data-sp-wishlist-handle'),
        title: btn.getAttribute('data-sp-wishlist-title'),
        price: btn.getAttribute('data-sp-wishlist-price'),
        comparePrice: btn.getAttribute('data-sp-wishlist-compare'),
        image: btn.getAttribute('data-sp-wishlist-image'),
        url: btn.getAttribute('data-sp-wishlist-url')
      };

      var added = toggleWishlist(product);
      if (added) {
        btn.classList.add('sp-wishlisted');
        showToast(product.title + ' added to wishlist');
      } else {
        btn.classList.remove('sp-wishlisted');
        showToast('Removed from wishlist');
      }
    });
  }

  function showToast(msg) {
    var existing = document.querySelector('.sp-wishlist-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'sp-wishlist-toast';
    toast.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#7b2d8e" stroke="#7b2d8e" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg> ' + msg;
    document.body.appendChild(toast);
    setTimeout(function() { toast.classList.add('sp-wishlist-toast--show'); }, 10);
    setTimeout(function() {
      toast.classList.remove('sp-wishlist-toast--show');
      setTimeout(function() { toast.remove(); }, 300);
    }, 2500);
  }

  function renderWishlistPage() {
    var container = document.getElementById('sp-wishlist-items');
    if (!container) return;

    var list = getWishlist();
    var empty = document.getElementById('sp-wishlist-empty');

    if (list.length === 0) {
      container.style.display = 'none';
      if (empty) empty.style.display = 'block';
      return;
    }

    if (empty) empty.style.display = 'none';
    container.style.display = 'grid';

    var html = '';
    list.forEach(function(item) {
      html += '<div class="sp-wishlist-card" data-handle="' + item.handle + '">'
        + '<a href="' + item.url + '" class="sp-wishlist-card__img-wrap">'
        + '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">'
        + '</a>'
        + '<div class="sp-wishlist-card__info">'
        + '<a href="' + item.url + '" class="sp-wishlist-card__title">' + item.title + '</a>'
        + '<p class="sp-wishlist-card__price">' + item.price + '</p>'
        + '<div class="sp-wishlist-card__actions">'
        + '<a href="' + item.url + '" class="sp-wishlist-card__view-btn">View Product</a>'
        + '<button class="sp-wishlist-card__remove" data-remove-handle="' + item.handle + '" aria-label="Remove">'
        + '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>'
        + '</button>'
        + '</div>'
        + '</div>'
        + '</div>';
    });
    container.innerHTML = html;

    container.querySelectorAll('[data-remove-handle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var handle = this.getAttribute('data-remove-handle');
        removeFromWishlist(handle);
        var card = this.closest('.sp-wishlist-card');
        card.style.opacity = '0';
        card.style.transform = 'scale(0.9)';
        setTimeout(function() {
          card.remove();
          updateButtons();
          if (getWishlist().length === 0) {
            container.style.display = 'none';
            if (empty) empty.style.display = 'block';
          }
        }, 300);
      });
    });
  }

  // Init
  document.addEventListener('DOMContentLoaded', function() {
    bindButtons();
    updateButtons();
    updateCounts();
    renderWishlistPage();
  });

  // Expose for external use
  window.spWishlist = {
    get: getWishlist,
    add: addToWishlist,
    remove: removeFromWishlist,
    toggle: toggleWishlist,
    isIn: isInWishlist,
    updateButtons: updateButtons
  };
})();
